export default __webpack_public_path__ + "static/media/Division_03.b430fd6b.png";